import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Dialog, IconButton } from 'react-toolbox';
import { sendQuickScheduleMessage } from 'actionCreators';
import SchedulePhaseAppointment from '../../tabs/phaseAppointments/components/schedulePhaseAppointment';
import PhaseType from 'types/phase';
import modalStyles from 'modal.scss';
import S from './quickScheduleModal.scss';

class QuickScheduleModal extends React.Component {
  handleSubmit = (phaseId, apptParams) =>
    this.props.sendQuickScheduleMessage(phaseId, apptParams).then((action) => {
      if (action && action.type === 'SEND_QUICK_SCHEDULE_MESSAGE_SUCCESS') {
        this.props.onClose();
      }
      return action;
    });

  apptTypeForPhase = () => {
    const { type } = this.props.phase;
    if (type === 'Assessment') return 'assessment_hold';
    if (type === 'Workorder') return 'workorder_hold';
    return 'installation_hold';
  }

  render = () => (
    <Dialog
      active={this.props.active}
      className={`${modalStyles.modal} ${S.wideModal}`}
      onEscKeyDown={this.props.onClose}
      onOverlayClick={this.props.onClose}
    >
      <IconButton icon="close" className={modalStyles.close} onClick={this.props.onClose} />
      <h5>Quick Schedule</h5>
      <p>Schedule a hold and text the customer to confirm.</p>
      {this.props.active && (
        <SchedulePhaseAppointment
          quickSchedule={{
            onSubmit: this.handleSubmit,
            label: 'Send Quick Schedule',
            forceKind: this.apptTypeForPhase(),
          }}
        />
      )}
    </Dialog>
  );
}

QuickScheduleModal.propTypes = {
  active: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  phase: PhaseType.isRequired,
  sendQuickScheduleMessage: PropTypes.func.isRequired,
};

export default connect(null, { sendQuickScheduleMessage })(QuickScheduleModal);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/phaseActionMenu/quickScheduleModal.jsx